export default "<div id=\"html5-qrcode\" class=\"html5-qrcode-reader\"> </div>";